/*
 This file is part of GNU Taler
 (C) 2021-2024 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.

 GNU Taler is distributed in the hope that it will be useful, but WITHOUT ANY
 WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 A PARTICULAR PURPOSE.  See the GNU General Public License for more details.

 You should have received a copy of the GNU General Public License along with
 GNU Taler; see the file COPYING.  If not, see <http://www.gnu.org/licenses/>
 */

// FIX default import https://github.com/microsoft/TypeScript/issues/49189
import {
  AccessToken,
  TalerHttpError,
  TalerMerchantApi,
  TalerMerchantManagementResultByMethod,
} from "@gnu-taler/taler-util";
import _useSWR, { SWRHook, mutate } from "swr";
import { useSessionContext } from "../context/session.js";
const useSWR = _useSWR as unknown as SWRHook;

export function revalidateExchanges() {
  return mutate(
    (key) => Array.isArray(key) && key[key.length - 1] === "listExchanges",
    undefined,
    { revalidate: true },
  );
}
export function useBackendExchanges() {
  const { lib } = useSessionContext();

  async function fetcher([]: [AccessToken, string]) {
    const list = await lib.instance.listExchanges();
    if (list.type === "ok") {
      list.body.exchanges.sort(importantFirst);      
    }
    return list;
  }

  const { data, error } = useSWR<
    TalerMerchantManagementResultByMethod<"listExchanges">,
    TalerHttpError
  >(["listExchanges"], fetcher, {
    refreshInterval: 5000,
  });

  if (error) return error;
  if (data === undefined) return undefined;
  if (data.type !== "ok") return data;

  return data;
}

function importantFirst(
  a: TalerMerchantApi.ExchangeStatusDetail,
  b: TalerMerchantApi.ExchangeStatusDetail,
): 0 | 1 | -1 {
  return 0;
}
